import { userGroups } from "@/endpoints/dryp/userGroups";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";

import { observer } from "mobx-react-lite";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router";
import { Routes } from "@/config/routes";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ColumnDef } from "@tanstack/react-table";
import { useServerTable } from "@/hooks/useServerTable";
import { mockServerTableQuery, QueryParams } from "@/utils/mockServerTableQuery";
import { List } from "@/components/List";

// interface ActionsProps {
// 	userGroup: Dryp.UserGroup;
// 	onDeleteCallback: () => {};
// }

const Columns: ColumnDef<any>[] = [
	{
		accessorKey: "Name",
		header: "Name",
	},
	{
		accessorKey: "Description",
		header: "Description",
	},
	{
		accessorKey: "IdUsers",
		header: "Users",
		cell: ({ getValue }) => {
			const users = getValue<any[]>();
			return users?.length ?? 0;
		},
	},
	{
		accessorKey: "IdsPointGroups",
		header: "Point Groups",
		cell: ({ getValue }) => {
			const pointGroups = getValue<any[]>();
			return pointGroups?.length ?? 0;
		},
	},
];

// const Actions: React.FC<ActionsProps> = observer(({ userGroup, onDeleteCallback }) => {
// 	const deleteUserGroupsApi = useAsyncStateStore(userGroups.deleteUserGroup);
// 	const navigate = useNavigate();
// 	const onClickEditUserGroup = () => {
// 		const path = generatePath(Routes.EditUserGroup, { userGroupId: userGroup.IdUserGroup });
// 		navigate(path);
// 	};

// 	const onClickDeleteUserGroup = async () => {
// 		try {
// 			await deleteUserGroupsApi.fetch({ idUserGroup: userGroup.IdUserGroup });
// 			onDeleteCallback();
// 		} catch (error) {}
// 	};
// 	return (
// 		<div className="flex gap-2">
// 			<Button onClick={() => onClickEditUserGroup()} size="sm" variant="outline">
// 				Edit
// 			</Button>

// 			<Button
// 				disabled={deleteUserGroupsApi.loading}
// 				onClick={() => onClickDeleteUserGroup()}
// 				size="sm"
// 				variant="destructive"
// 			>
// 				{deleteUserGroupsApi.loading ? "Deleting" : "Delete"}
// 			</Button>
// 		</div>
// 	);
// });

const fetchUserGroups = async (params: QueryParams) => {
	const response = await userGroups.getUserGroups();
	const data = mockServerTableQuery({
		data: response || [],
		page: params.page,
		pageSize: params.pageSize,
		filters: params.filters,
		sort: params.sort,
	});
	return data;
};

export const UserGroups = observer(() => {
	const getUserGroupsApi = useAsyncStateStore(fetchUserGroups);
	const navigate = useNavigate();

	const onClickAddUserGroup = () => {
		navigate(Routes.Dashboard.Admin.AddUserGroup.path);
	};

	const userGroups = getUserGroupsApi.data?.queryData || [];
	const { table } = useServerTable({
		columns: Columns,
		data: userGroups,
		fetchFn: params => getUserGroupsApi.fetch(params),
		initialValues: {
			page: 1,
			pageSize: 5,
		},
	});

	return (
		<Card className="m-4">
			<CardContent>
				<CardHeader>
					<div className="flex w-full">
						<CardTitle className="text-nowrap">User groups</CardTitle>
						<div className="flex justify-end w-full">
							<Button onClick={onClickAddUserGroup} size="sm">
								+ Add
							</Button>
						</div>
					</div>
				</CardHeader>
				<List
					table={table}
					pagination={{
						total: getUserGroupsApi.data?.pagination.total || 0,
					}}
					toolbar={{
						filterKey: "Name",
					}}
					layout={{
						loading: getUserGroupsApi.loading,
					}}
				/>
			</CardContent>
		</Card>
	);
});
